/**
 * Browser bootstrap for React, routing, global styles, and PWA service-worker registration. The
 * root application owns authentication and planner lifecycle.
 *
 * @module apps/web/src/main
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/*
      Navigation renders synchronously, in the input's own task, so the new screen paints in the
      next frame. With transitions (React Router's default) the browser paints the click frame
      first and the screen a frame later: at least two frames, about 33 ms. Retained screens
      (KeepAliveRoutes) make a synchronous reveal cheap.
    */}
    <BrowserRouter useTransitions={false}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    const appBundle = new URL(import.meta.url).pathname.split('/').pop() || 'app';
    navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(appBundle)}`, { updateViaCache: 'none' }).catch(error => {
      console.warn('Service worker registration failed', error);
    });
  });
}
